function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P3Billions = function P3Billions(_ref) {
  var page = _ref.page;
  var thisPage = 5;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p3-billions__50').addClass('p3-billions__50--active');
      }, 1500), setTimeout(function () {
        $('.p3-50-m').addClass('p3-50-m__active');
      }, 1500), setTimeout(function () {
        $('.p3-text').addClass('p3-text__active');
      }, 1500)]);
    } else {
      $('.p3-billions__50').removeClass('p3-billions__50--active');
      $('.p3-50-m').removeClass('p3-50-m__active');
      $('.p3-text').removeClass('p3-text__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p3-billions"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/50-billion@3x.png",
    className: "p3-billions__50"
  }), /*#__PURE__*/React.createElement("div", {
    className: "p3-sand"
  }, _toConsumableArray(Array(25)).map(function (x, i) {
    return i;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(Sand, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "sand".concat(x)
    });
  }))), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/blurb-sustainability@2x.png",
    className: "p3-text"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/50-billion@3x.png",
    className: "p3-50-m"
  }), /*#__PURE__*/React.createElement("div", {
    className: "p3-sand-m"
  }, _toConsumableArray(Array(25)).map(function (x, i) {
    return i;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(Sand, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "sand-m".concat(x)
    });
  })));
};
export default P3Billions;
var Sand = function Sand(_ref2) {
  var nr = _ref2.nr,
    page = _ref2.page,
    thisPage = _ref2.thisPage;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    tSand = _useState4[0],
    setTSand = _useState4[1];
  var clearTimers = function clearTimers() {
    if (tSand) clearTimeout(tSand);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTSand(setTimeout(function () {
        $(".p3-sand__".concat(nr)).addClass('p3-sand__active');
      }, 1500 + nr * 250));
    } else {
      $(".p3-sand__".concat(nr)).removeClass('p3-sand__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/sand@3x.png",
    className: "p3-sand__".concat(nr)
  }));
};